import {
  cloneUnmanagedBusinessAutoRegisterCondition,
  normalizeUnmanagedBusinessAutoRegisterCondition,
} from '@/coreDomainsModule/constants/unmanagedBusinessAutoRegister';
import {
  PutUnmanagedBusinessAutoRegisterSettingRequest,
  UnmanagedBusinessAutoRegisterSettingResult,
} from '@/coreInfrastructureModule/axios/generated/settingManage/api';
import { UnmanagedBusinessAutoRegisterSettingEntity } from '../domains/entities/unmanagedBusinessAutoRegisterSetting';

/**
 * 未管理取引の自動登録設定のAPIモデルとドメインを相互変換するAdapter
 */
export class UnmanagedBusinessAutoRegisterSettingAdapter {
  /**
   * APIレスポンスをドメインへ変換する
   * @param result - APIレスポンス
   */
  public static toEntity(result: UnmanagedBusinessAutoRegisterSettingResult): UnmanagedBusinessAutoRegisterSettingEntity {
    return {
      condition: normalizeUnmanagedBusinessAutoRegisterCondition(result.setting.condition),
      updateAt: typeof result.setting.updateAt === 'number' ? result.setting.updateAt : undefined,
    };
  }

  /**
   * ドメインをAPIリクエストへ変換する
   * @param setting - ドメイン設定
   */
  public static toPutRequest(setting: UnmanagedBusinessAutoRegisterSettingEntity): PutUnmanagedBusinessAutoRegisterSettingRequest {
    return {
      condition: cloneUnmanagedBusinessAutoRegisterCondition(setting.condition),
      updateAt: setting.updateAt,
    };
  }
}
